'use strict';

import ReactDOM from "react-dom/client";
import React from 'react';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { persistStore } from 'redux-persist';
import { ThemeProvider } from "@mui/material";
import { PrimeReactProvider } from 'primereact/api';
import { appTheme } from "./components/themes/Theme"

import { configureStore, history } from './_redux/_store';
import App from './App';
//

import CssBaseline from '@mui/material/CssBaseline';

// import 'bootstrap/dist/css/bootstrap.min.css';
import '@progress/kendo-theme-material/dist/all.css';

import './styles/styles.scss';

const store = configureStore();
const persistor = persistStore(store);

ReactDOM.createRoot(document.getElementById("app")).render(
    <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <PrimeReactProvider>
            <App history={history} store={store} persistor={persistor} />
        </PrimeReactProvider>
    </ThemeProvider>

);
